import React from 'react';
import { Layout } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import UserProfile from './UserProfile';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <AntHeader className="app-header">
      <div className="header-content">
        <div className="logo-section">
          <img 
            src="https://assets.agridence.com/logos/agd-logo.png" 
            alt="Agridence" 
            className="logo"
          />
          <div className="header-title-container">
            <h1 className="header-title">EUDR Knowledge Agent</h1>
            <span className="header-subtitle">EU Deforestation Regulation Compliance</span>
          </div>
        </div>
        
        {isAuthenticated && (
          <div className="header-profile-section">
            <UserProfile />
          </div>
        )}
      </div>
    </AntHeader>
  );
};

export default Header;